import { sendGAEvent } from '@noths/polaris-client-google-analytics';

export const trackReviewsImpression = () => {
  sendGAEvent({
    event: 'custom_event',
    event_category: 'Product reviews',
    event_action: 'Impression',
    event_label: 'not set',
  });
};

export const trackRatingSystemInfoClick = () => {
  sendGAEvent({
    event_action: 'Product rating system click',
    event_category: 'Product reviews',
    event_label: 'not set',
    event: 'custom_event',
  });
};

export const trackReviewToggle = () => {
  sendGAEvent({
    event_action: 'Expand review click',
    event_category: 'Product reviews',
    event_label: 'not set',
    event: 'custom_event',
  });
};

export const trackPaginationClick = (page: number) => {
  sendGAEvent({
    event_action: 'Pagination click',
    event_category: 'Product reviews',
    event_label: String(page),
    event: 'custom_event',
  });
};

export const trackNextPageClick = (page: number) => {
  sendGAEvent({
    event_action: 'Next page click',
    event_category: 'Product reviews',
    event_label: String(page),
    event: 'custom_event',
  });
};
